import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";

const app = getApp();
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // generate qr code.
  const clientOrderBailiffQRGenerate = httpsCallable(
    functions,
    "api-client-order-bailiff-qr-generate",
  ); // {id}

  const draftDialogTakeOver = httpsCallable(
    functions,
    "api-draft-dialog-take-over", // test thử nhớ sửa
  ); //
  const draftDialogLeaveTask = httpsCallable(
    functions,
    "api-draft-dialog-leave-task",
  ); //
  const draftDialogUpdateSentence = httpsCallable(
    functions,
    "api-draft-dialog-update-sentence",
  ); // {slot, text} //
  const draftDialogCompleteTask = httpsCallable(
    functions,
    "api-draft-dialog-complete-task",
  ); // -> truyền nothing.

  // rút tiền.
  const withdrawBailiffWallet = httpsCallable(
    functions,
    "api-payment-withdraw-order-generate",
  ); // {amount, source: bailiff, accountNumber, code, accountName}

  // thêm tài khoản.
  const bankAddAccount = httpsCallable(functions, "api-bank-add-account"); // { accountName, accountNumber, code }
  // xóa tài khoản.
  const bankDeleteAccount = httpsCallable(functions, "api-bank-delete-account"); // {id}

  // return.
  return {
    client: {
      clientOrderBailiffQRGenerate,
    },
    dialog: {
      draftDialogTakeOver,
      draftDialogLeaveTask,
      draftDialogUpdateSentence,
      draftDialogCompleteTask,
    },
    payment: {
      withdrawBailiffWallet,
    },
    bank: {
      bankAddAccount,
      bankDeleteAccount,
    },
  };
};
